import { render, staticRenderFns } from "./UcInvoicePayments.yaml?vue&type=template&id=4962bc62&component"
import script from "./UcInvoicePayments.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoicePayments.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports